import { FC, ReactNode, useCallback, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import MaterialDialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogActions from "@mui/material/DialogActions";
import Box from "@mui/material/Box";

const BootstrapDialog = styled(MaterialDialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
}));

interface DialogProps {
  title: string;
  isOpen: boolean;
  children: ReactNode;
  maxWidth?: "lg" | "sm" | "md" | "xs" | "xl";
  action?: ReactNode;
  actionClassName?: string;
  onClose: () => void;
  className?: string;  // PR 7831723 
  floatingClose?: boolean;  // PR 7831723 
  disableBackdropClose?: boolean;  // PR 7831723 
}

const Dialog: FC<DialogProps> = ({
  isOpen,
  title,
  children,
  maxWidth,
  action,
  actionClassName,
  onClose,
  // PR 7831723 Start
  className,
  floatingClose,
  disableBackdropClose,
  // PR 7831723 End
}) => {
  // PR 7831723 Start
  const [isAttention, setIsAttention] = useState(false);

  useEffect(() => {
    if (!isAttention) return;

    const timer = setTimeout(() => setIsAttention(false), 700);
    return () => clearTimeout(timer);
  }, [isAttention]);

  const handleDialogClose = useCallback(
    (event: object, reason: "backdropClick" | "escapeKeyDown") => {
      if (
        disableBackdropClose &&
        (reason === "backdropClick" || reason === "escapeKeyDown")
      ) {
        setIsAttention(true);
        return;
      }

      onClose();
    },
    [disableBackdropClose, onClose]
  );
  // PR 7831723 End

  return (
    <BootstrapDialog
      onClose={handleDialogClose}   // PR 7831723 
      aria-labelledby="popup-title"
      open={isOpen}
      maxWidth={maxWidth || "xl"}
      fullWidth
      // PR 7831723 start
      className={`${className || ""} ${
        isAttention ? "popup-attention-bounce" : ""
      }`.trim()}
      PaperProps={{
        "aria-modal": true,
      }}
    >
      {floatingClose && !title ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          className="popup-floating-close"
        >
          <CloseIcon />
        </IconButton>
      ) : (
        // PR 7831723 End
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
        >
          <DialogTitle id="popup-title" className="popup-title red-pastel" sx={{ m: 0, p: 2 }}>
            {title}
          </DialogTitle>
          <Box padding={2}>
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                color: (theme) => theme.palette.grey[900],
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
      )}

      <DialogContent>{children}</DialogContent>
      {action && <DialogActions className={actionClassName}>{action}</DialogActions>}
    </BootstrapDialog>
  );
};

export default Dialog;
